<template>
    <modal
        class="min-h-full"
        :open="modal"
        @close="$emit('close')"
    >
        <div class="flex flex-col flex-wrap w-full divide-y space-y-3 divide-slate-500 text-gray-900 dark:text-white min-h-fit">
        </div>
        <h1 class="text-lg text-gray-900 dark:text-white font-bold text-sm flex flex-row flex-wrap items-center content-center border-b border-slate-500 pb-1 mb-2">
            Remover Custo {{cost.name}}
        </h1>

        <div class="flex flex-col dark:text-white space-y-3 mb-2">
            <div><strong>Categoria: </strong>{{cost.category}}</div>
            <div><strong>Data: </strong>{{cost.date}}</div>
            <div><strong>Valor: </strong>{{$root.formatCurrency(cost.amount)}}</div>
            <div><strong>Descrição: </strong>{{cost.description}}</div>
        </div>

        <submit-button @click.prevent="submit"  :loading="loading" class="w-full">Remover</submit-button>
    </modal>
</template>

<script>
    import Modal from "../../layouts/Modal.vue";
    import SubmitButton from "../../forms/SubmitButton.vue";
    import InfoCol from "../../layouts/InfoCol.vue";

    export default {
        components: {InfoCol, SubmitButton, Modal},
        props: ['cost', 'modal'],
        emits: ['fetch'],
        data() {
            return {
                show: false,
                loading: false,
            }
        },

        methods: {
            submit() {
                this.loading = true;
                axios.delete(`/api/cost/${this.cost.id}`,).then(response => {
                    this.loading = false;
                    this.$emit('fetch');
                }).catch(error => {
                    this.loading = false;
                });
            }
        }
    }
</script>
